import React, { useState, useEffect, useRef } from 'react';
import { PostRequest, GetRequest, Tooltip } from 'components/common';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';
import { ContentPopup } from 'components/ContentPopup.jsx';
import { ValidatorFactory } from 'components/common';
import { ListenCondition } from 'components/layout_and_quote_builder/quote_builder/form_fields/index.js'

const UserUnitPriceAttributeField = ({ config, value, setValue, unit, register, errors, disabled, setFetchInProgress, setChildSubFormOpen, options, readOnlyValues, context, requestPublishItemOnChange, item, navSection, values, onAttributesLoaded }) => {
  const VALUE_NEW = "new-attribute";
  const VALUE_NOT_AVAILABLE = 'not-available'
  const VALUE_EMPTY = "";

  const [attributes, setAttributes] = useState([]);
  const [sourceAttributes, setSourceAttributes] = useState(null);
  const [validationError, setValidationError] = useState('');
  const [newAttributeValue, setNewAttributeValue] = useState('');
  const [newAttributesAdded, setAttributesAdded] = useState(false);
  const [newAttributeFormError, setNewAttributeFormError] = useState('');

  const [readOnly, setReadOnly] = useState(false);
  const [defaultValue, setDefaultValue] = useState(config.default_value);
  const [editing, setEditing] = useState(false);
  const [editNameValue, setEditNameValue] = useState('');
  const [editNameError, setEditNameError] = useState('');
  const editPopupRef = useRef();

  const validate = (val) => {
    if(config.validators != undefined) {
      for(let i=0; i< config.validators.length; i++) {
        let validator = config.validators[i];
        if(!ValidatorFactory(validator, value)) {
          setValidationError(t(`quote_builder.validator_${validator}_message`));
          return t(`quote_builder.validator_${validator}_message`);
        }
      }
    }
    setValidationError('');
    return;
  }

  const handleOnChange = (e) => {
    setValue(config.name, e.target.value);
  }

  const materialIdByyMaterialAttribute = (material_attribute) => {
    var name_en = undefined;

    name_en = {
      carton_material_user_price_id: 'Carton',
      hard_cardboard_material_user_price_id: 'Hard cardboard',
      pvc_material_user_price_id: 'PVC',
      corrugated_cardboard_material_user_price_id: 'Corrugated cardboard',
    }[material_attribute];

    if(navSection != undefined && navSection.part_type == 'carton_lamination' && name_en == 'Carton') {
      name_en = 'Carton + Corrugated Cardboard (Lamination)'
    }

    if(name_en == undefined || attributes.length == 0)   { return undefined }

    let attribute = Array.from(attributes).find((attribute) => attribute.name_en == name_en );
    if(attribute == undefined) { return undefined }

    return attribute.id;
  }

  useEffect(() => {
    if(attributes.length == 0) { return; }

    if (readOnlyValues != undefined) {
      readOnlyValues.map((readOnlyValue) => {
        if(readOnlyValue.name == config.name) {

          if(readOnlyValue.value_eval != undefined) {
            let _value = eval(readOnlyValue.value_eval);
            if (_value != undefined && _value != '') {
              setTimeout(() => {
                setValue(config.name, () => { return _value } );
                setReadOnly(readOnlyValue.make_read_only == undefined ? (_prev) => true :  (_prev) => readOnlyValue.make_read_only );
              }, 250)
            }
          }
        }
      })
    }

    if(context != undefined) {
      for (const [contextKey, contextValue] of Object.entries(context)) {
        if(contextKey == config.key) {
          setTimeout(() => {
            setValue(config.name, () => { return contextValue } );
          }, 250);
        }
      }
    }
  }, [attributes])

  const fetchUserUnitPriceAttributes = (callback) => {
    if(disabled) { return; }

    setFetchInProgress(true);

    GetRequest({
      url: `/quote-builder/user_unit_price_attributes/list/${config.key}`,
      callback: (data) => {
        setAttributes(data);
        // Report loaded attributes (with properties) up so the form can resolve vap() expressions.
        if(onAttributesLoaded != undefined) { onAttributesLoaded(data); }
        if(callback != undefined) { callback(); }
        setFetchInProgress(false);
      }
    })
  }

  useEffect(fetchUserUnitPriceAttributes, []);

  useEffect(() => {
    if (!config.filter_attributes_from) { return; }

    const sourceKey = config.filter_attributes_from.replace('user_unit_price_attribute.', '');
    GetRequest({
      url: `/quote-builder/user_unit_price_attributes/list/${sourceKey}`,
      callback: (data) => {
        setSourceAttributes(data);
      }
    });
  }, []);

  const getFilteredAttributes = () => {
    if (!config.filters || !attributes.length) { return attributes; }

    let selectedSourceAttribute = null;
    if (config.filter_attributes_from && sourceAttributes && values) {
      let sourceValue = values[config.filter_attributes_from];
      if (sourceValue && sourceValue !== VALUE_NEW && sourceValue !== VALUE_EMPTY) {
        selectedSourceAttribute = sourceAttributes.find((attribute) => String(attribute.id) === String(sourceValue));
      }
    }

    let data = attributes;
    for (let i = 0; i < config.filters.length; i++) {
      data = data.filter((attribute) => { return eval(config.filters[i].filter); });
    }
    return data;
  };

  const filteredAttributes = getFilteredAttributes();

  useEffect( () => {
    if(value != '' && value != undefined && value !='new-attribute' ) { return; }

    let valueToSet = attributes.length > 0 ? (config.empty_option_enabled ? VALUE_EMPTY : (config.not_available_enabled ? VALUE_NOT_AVAILABLE : attributes[0].id)) : (config.not_available_enabled ? VALUE_NOT_AVAILABLE : (config.create_enabled ? VALUE_NEW : VALUE_EMPTY))

    if(newAttributesAdded) {
      valueToSet = attributes.length > 0 ? attributes[attributes.length - 1].id : (config.not_available_enabled ? VALUE_NOT_AVAILABLE : (config.create_enabled ? VALUE_NEW : VALUE_EMPTY))
    }

    if(defaultValue != '' && defaultValue != undefined) {
      for(let i=0; i< attributes.length; i++) {
        if (attributes[i].name_en == defaultValue) {
          setValue(config.name, attributes[i].id);
          return;
        }
      }
    }

    setValue(config.name, (prev) => { return valueToSet } );

  }, [attributes])

  useEffect(() => {
    if (config.create_enabled && config.create_sub_form != undefined && setChildSubFormOpen) {
      setChildSubFormOpen(value == VALUE_NEW);
    }
    return () => {
      if (setChildSubFormOpen) { setChildSubFormOpen(false); }
    };
  }, [value])

  const saveNewAttributeValue = () => {
    if(newAttributeValue == '') { setNewAttributeFormError('quote_builder.missing_value_error'); return; }
    setFetchInProgress(true);

    PostRequest({
      url: `/quote-builder/user_unit_price_attributes/create/${config.key}`,
      data: {
        name: newAttributeValue,
      },
      callback: (_data) => {
        setAttributesAdded(true);
        setNewAttributeFormError('');
        fetchUserUnitPriceAttributes();
        setValue(config.name, _data.new_attribute_id);
        setNewAttributeValue('');
        setFetchInProgress(false);
      },
      400: (data) => {
        setNewAttributeFormError( 'quote_builder.invalid_value_error' );
        setFetchInProgress(false);
      }
    })
  }

  const closeNewAttributeForm = () => {
    setNewAttributeValue('');
    setValue(config.name, attributes[0]?.id);
  }

  const newAttributeForm = () => {
    return (
      <div className="form-inline newAttributeForm">
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon">
              {config.create_input_label != undefined && t(config.create_input_label)}
              {config.create_input_label == undefined && t('quote_builder.new_attribute_with_key').replace('%{key}', t(`quote_builder.${config.key}`).toLowerCase())}
              </div>
              <input
                type="text"
                className={newAttributeFormError != '' ? 'input-error form-control' : 'form-control'}
                size="15"
                value={newAttributeValue}
                onChange={(e) => {setNewAttributeValue(e.target.value)}}
                />
            </div>
          </div>

          <button type="button" className="btn simple-btn" onClick={saveNewAttributeValue} > {t('quote_builder.save')} </button> &nbsp;
          <button className="btn" type="button" onClick={closeNewAttributeForm}> {t('quote_builder.cancel')} </button>

          {newAttributeFormError != '' && <center> <small className="error"> {t(newAttributeFormError)} </small> </center> }
      </div>
    )
  }

  const newAttributeSubForm = () => {
    const afterSave = () => {
      setAttributesAdded(true);
      fetchUserUnitPriceAttributes();
    }
    return (<div>
      <QuoteBuilderForm config={config.create_sub_form} afterSave={afterSave} afterCancel={afterSave} readOnlyValues={readOnlyValues} context={context} options={options} />
    </div>)
  }

  // Modal editor for the currently selected attribute, opened from the "edit" link. Attributes that
  // carry a rich create_sub_form (machines, sheet dimensions, ...) are edited with that same form via
  // QuoteBuilderForm's UserUnitPriceAttribute edit mode (fetch /properties/:id, save
  // /update_properties/:id) — exactly what the standalone "Printing and cutting machines" list uses.
  // Name-only attributes (a brand, a type, ...) are edited with a single name field via update_name,
  // mirroring this field's own create flow. Both are shown in a ContentPopup, the same modal
  // UserUnitPrice uses to edit a price.
  const closeEditor = () => {
    setEditing(false);
    setEditNameError('');
    if (editPopupRef.current) { editPopupRef.current.style.display = "none"; }
  }

  const startEditing = (e) => {
    e.preventDefault();
    if (config.create_sub_form == undefined) {
      setEditNameValue(selectedAttribute != undefined ? selectedAttribute.name : '');
      setEditNameError('');
    }
    setEditing(true);
  }

  // The rich edit modal shows the sub-form's edit_title in its header. Several sub-forms only define
  // new_title, which leaves the edit modal header blank. Fall back to this picker's own label (an
  // existing, already-translated key) so the modal is always titled — e.g. editing a layer shows
  // "2nd layer". Sub-forms that do define edit_title (machines, material types, ...) keep it.
  const editSubFormConfig = () => {
    const subForm = config.create_sub_form;
    if (subForm.edit_title != undefined) { return subForm; }
    const fallbackTitle = config.label != undefined ? config.label : `quote_builder.${config.key}`;
    return { ...subForm, edit_title: fallbackTitle };
  }

  const editAttributePopup = () => {
    const afterSave = () => {
      closeEditor();
      // The selected id is unchanged; re-fetch so the dropdown label reflects any edits (renamed
      // machine, changed dimensions, ...).
      fetchUserUnitPriceAttributes();
    }
    // Match the standalone "… machines"/"… types" list editor (SettingsUserUnitPriceAttributeList):
    // it passes NO context/readOnlyValues into the edit form. In edit mode the form fetches and seeds
    // the record's real saved values, and a stray context/readOnlyValues write could clobber them.
    const content = (
      <QuoteBuilderForm config={editSubFormConfig()}
        showingState="edit" editStateId={value} editedKlass="UserUnitPriceAttribute" linkToSettings={false}
        afterSave={afterSave} afterCancel={closeEditor} />
    )
    return <ContentPopup myRef={editPopupRef} autoOpen={true} content={content} cancelButton={false} beforeClose={() => setEditing(false)} />
  }

  const saveEditedName = () => {
    if (editNameValue == '') { setEditNameError('quote_builder.missing_value_error'); return; }
    setFetchInProgress(true);

    // .catch handles EVERY failure status uniformly (400 invalid value, but also 403 not-editable,
    // 404, 500): clear the in-progress flag and keep the editor open with an error. Handling only 400
    // would leave the parent form stuck in its loading/disabled state on any other status.
    PostRequest({
      url: `/quote-builder/user_unit_price_attributes/update_name/${value}`,
      data: { name: editNameValue },
      callback: (_data) => {
        closeEditor();
        fetchUserUnitPriceAttributes();
      }
    }).catch((_error) => {
      setEditNameError('quote_builder.invalid_value_error');
      setFetchInProgress(false);
    })
  }

  // Name-only attributes get a lightweight inline editor (a single name field), rendered under the
  // dropdown just like this field's own "create" name form — a full modal for one field looks broken.
  // The rich multi-field editor above stays a modal (it has its own title and many fields).
  const editNameForm = () => {
    return (
      <div className="form-inline newAttributeForm" style={{ marginTop: '4px' }}>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon">
              { config.label != undefined ? t(config.label) : defaultLabel() }
            </div>
            <input
              type="text"
              className={editNameError != '' ? 'input-error form-control' : 'form-control'}
              size="25"
              value={editNameValue}
              onChange={(e) => { setEditNameValue(e.target.value) }}
            />
          </div>
        </div>

        <button type="button" className="btn simple-btn" onClick={saveEditedName}> {t('quote_builder.save')} </button> &nbsp;
        <button className="btn" type="button" onClick={closeEditor}> {t('quote_builder.cancel')} </button>

        {editNameError != '' && <center> <small className="error"> {t(editNameError)} </small> </center> }
      </div>
    )
  }

  const defaultLabel = () => {
    return t(`quote_builder.${config.key}`);
  }

  const defaultCreateCta = () => {
    return t(`quote_builder.new_user_unit_price`).replace("%s", t(`quote_builder.${config.key}`))
  }

  const callRequestPublishItemOnChange = () => {
    if(config.publish_item_on_change && config.publish_item_if_eval == undefined) {
      requestPublishItemOnChange({ publish_item_key: config.publish_item_key });
    }

    if(config.publish_item_on_change && config.publish_item_if_eval != undefined && eval(config.publish_item_if_eval) ) {
      requestPublishItemOnChange({ publish_item_key: config.publish_item_key });
    }
  }

  useEffect(() => {
    callRequestPublishItemOnChange();
  }, [value])

  // Close the edit popup whenever the selection changes, so the open editor always matches the
  // currently selected attribute (QuoteBuilderForm captures editStateId at mount) and can never
  // edit a stale id after the user picks a different option.
  useEffect(() => {
    setEditing(false);
  }, [value])

  const sourceFieldValue = config.filter_attributes_from && values ? values[config.filter_attributes_from] : null;

  useEffect(() => {
    if (!config.filter_attributes_from || !sourceAttributes || filteredAttributes.length === 0) { return; }
    if (value === VALUE_NEW || value === VALUE_EMPTY || value === VALUE_NOT_AVAILABLE) { return; }

    const currentSelectionValid = filteredAttributes.some((attribute) => String(attribute.id) === String(value));
    if (!currentSelectionValid) {
      setValue(config.name, filteredAttributes[0].id);
    }
  }, [sourceFieldValue, sourceAttributes, value, attributes])

  const noOp = () => { }

  if(config.listen_conditions != undefined) {
    for(let i=0; i < config.listen_conditions.length; i++) {

      useEffect(() => {
        let listener = ListenCondition.listener({
          config: config,
          condition: config.listen_conditions[i],
          item: item,
          navSection: navSection,
          setValue: setValue,
          GetRequest: GetRequest,
          setReadOnly: setReadOnly,
          setReadOnlyMessage: noOp,
          setNotAvailable: noOp,
          setNotAvailableReason: noOp,
          options: options,
          fetchUserUnitPrices: noOp,
          fetchSystemUnitPrices: noOp,
        });

        document.addEventListener(config.listen_conditions[i].listen, listener);
        return () => { document.removeEventListener(config.listen_conditions[i].listen, listener);}

      }, []);
    }
  }

  // The "edit" link is offered only for attributes that have their own settings tab (the
  // "Carton material types", "Layers", ... lists) — window.quote_builder_attribute_keys_with_tab is
  // populated on the pages that support the editor. Beyond that it requires an attribute the user
  // owns and can edit (can_be_edited is false for system and read-only records, so this is exactly
  // "my own, editable attribute") and a real selection (not the create / empty / not-available
  // sentinels). This mirrors the server, which scopes both the rich update (update_properties) and
  // the name update (update_name) to current_user and rejects non-editable records.
  const attributeHasListingTab =
    Array.isArray(window.quote_builder_attribute_keys_with_tab) &&
    window.quote_builder_attribute_keys_with_tab.includes(config.key);
  const selectedAttribute = attributes.find((attribute) => String(attribute.id) === String(value));
  const canEditSelectedAttribute =
    attributeHasListingTab &&
    !readOnly &&
    selectedAttribute != undefined &&
    selectedAttribute.can_be_edited &&
    value != VALUE_NEW && value != VALUE_EMPTY && value != VALUE_NOT_AVAILABLE;

  return (
    <tr>
      <td>
        { config.label != undefined && t(config.label) }
        { config.label == undefined && defaultLabel() }
        { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <select
          name={config.name}
          value={value}
          disabled={readOnly}
          className={`form-control general-frm-element ${validationError != '' ? 'input-error' : ''}`}
          {...register(config.name.replace('.', '_'), {
          validate: validate,
          onChange: handleOnChange
        })}
         >
        {config.empty_option_enabled && <optgroup label="" ><option key={VALUE_EMPTY} value={VALUE_EMPTY}> </option> </optgroup> }
        {config.not_available_enabled && <optgroup label="" ><option key="n/a" value={VALUE_NOT_AVAILABLE}> {t('quote_builder.not_included')} </option> </optgroup> }
        {filteredAttributes.map((attribute) => {
          return <option
            key={attribute.id}
            value={attribute.id}> { window.locale == 'en' ? (attribute.dropdown_label_en || attribute.name_en) : (attribute.dropdown_label_tr || attribute.name_tr) }
          </option>
        })}

        {config.create_enabled && <optgroup label="" ><option key="new_attribute" value={VALUE_NEW}>
        {config.create_cta != undefined && t(config.create_cta)}
        {config.create_cta == undefined && defaultCreateCta() }
        </option> </optgroup> }

      </select>

      { canEditSelectedAttribute && !editing &&
        <div className="qb-attribute-edit-link-row" style={{ marginTop: '4px' }}>
          <a href="#" className="qb-attribute-edit-link" onClick={startEditing}>
            <i className="fa fa-pencil-square-o" aria-hidden="true"></i> {t('quote_builder.edit')}
          </a>
        </div>
      }

      {validationError != '' && <small className="error"> {validationError} </small>}
      {config.create_enabled && value == VALUE_NEW && config.create_sub_form == undefined && newAttributeForm() }
      {config.create_enabled && value == VALUE_NEW && config.create_sub_form != undefined && newAttributeSubForm() }
      {editing && canEditSelectedAttribute && config.create_sub_form != undefined && editAttributePopup() }
      {editing && canEditSelectedAttribute && config.create_sub_form == undefined && editNameForm() }
      </td>
    </tr>
  )
}

export default UserUnitPriceAttributeField;
